import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { MaintenanceOffboardingModel } from '../maintenance-offboarding-models/maintenance-offboarding.models';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceOffboardingService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async saveOffboardingDetails(saveOffboarding: MaintenanceOffboardingModel) {

    const API_URL: string = environment.baseUrl + environment.apis.saveOffboardingDetails;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: saveOffboarding.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getOffboardingDetails(RepCode: string) {

    const API_URL: string = environment.baseUrl + environment.apis.getOffboardingDetails;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "pias_rep_code": RepCode,
        "updated_by_role": ['DSU', 'DSU Manager']
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async triggerEmail(payload: any) {
    const API_URL: string = environment.baseUrl + environment.apis.triggerOffboardingEmail;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: payload
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }


}
